module.exports = __webpack_public_path__ + "img/ring_r_e_1_null@2x.dbaa1506.png";